export const state = () => ({
  data: null,
  choices: [],
});

export const mutations = {
  SET_DATA(state, data) {
    state.data = data;
  },
  CLEAN(state) {
    state.data = null;
  },
};

export const getters = {
  getQuery(state) {
    if (state.data !== null) {
      return { isZwr: state.data };
    }
    return {};
  },
};

export const actions = {
  setData({ commit }, data) {
    commit('SET_DATA', data);
  },
  setDataFromQuery({ commit }, { isZwr }) {
    if (isZwr === 'true' || isZwr === 'false') {
      commit('SET_DATA', isZwr);
    } else {
      commit('SET_DATA', null);
    }
  },
  setChoices() {},
  clearChoices() {},
  fetchChoices() {},
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
